import { getBaseUrl, request } from 'src/helper/api';

export const getIntelligentSchedulingData = (
  marketId?: string,
  token?: string,
  signal?: AbortSignal,
) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/intelligent-routing/initial-scheduling-data${marketId ? `?market_id=${marketId}` : ''}`,
      contentType: 'json',
      token,
      signal,
    },
    'intelligent-scheduling/getIntelligentSchedulingData',
  );

export const runIntelligentSchedulingOptimizer = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/intelligent-routing/run`,
      contentType: 'json',
      token,
      signal,
    },
    'intelligent-scheduling/runOptimizer',
  );

export const getIntelligentRoutingStatus = (
  routing_request_uuid?: string,
  token?: string,
  signal?: AbortSignal,
) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/intelligent-routing/status?routing_request_uuid=${routing_request_uuid}`,
      contentType: 'json',
      token,
      signal,
    },
    'intelligent-scheduling/getRoutingStatus',
  );

export const applyIntelligentRoutingSuggestions = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/intelligent-routing/apply`,
      contentType: 'json',
      token,
      signal,
    },
    'intelligent-scheduling/applyRoutingSuggestions',
  );

export const getApplyStatus = (
  routing_request_uuid?: string,
  token?: string,
  signal?: AbortSignal,
) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/intelligent-routing/apply-status?routing_request_uuid=${routing_request_uuid}`,
      contentType: 'json',
      token,
      signal,
    },
    'intelligent-scheduling/getApplyStatus',
  );

export const setWorkOrderLock = (
  workOrderUuid?: string,
  lock?: boolean,
  token?: string,
  signal?: AbortSignal,
) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/intelligent-routing/work-orders/${workOrderUuid}/${lock ? 'lock' : 'unlock'}`,
      contentType: 'json',
      token,
      signal,
    },
    `intelligent-scheduling/lockUnlockWorkOrder`,
    { work_order_uuid: workOrderUuid, is_locked: lock },
  );

export const getSchedulingPendingCounter = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/intelligent-routing/pending-count`,
      contentType: 'json',
      token,
      signal,
    },
    'counter/getSchedulingPendingCounter',
  );

export const getBulkAvailabilityStatus = (token?: string) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/intelligent-routing/bulk-availability-status`,
      contentType: 'json',
      token,
    },
    'intelligent-scheduling/getBulkAvailabilityStatus',
  );
